import { z } from 'zod'

export const trainerSocialCleanupExceptionResponseSchema = z.record(z.unknown())
export type TrainerSocialCleanupExceptionResponse = z.infer<typeof trainerSocialCleanupExceptionResponseSchema>
